import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+500',
  label: 'Familias ayudadas'
}, {
  value: '10',
  label: 'Tomos listos'
}, {
  value: '7',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'Calificación ⭐'
}];
export function StatsBar() {
  return <section className="bg-navy py-6 px-6 border-y border-white/10" data-id="element-379">
      <div className="max-w-6xl mx-auto" data-id="element-380">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-2 divide-x-0 md:divide-x divide-white/10" data-id="element-381">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} style={{
          willChange: 'transform, opacity'
        }} className="flex flex-col items-center justify-center text-center px-4" data-id="element-382">
              <p className="text-5xl md:text-6xl font-bold text-gold mb-2 font-display" data-id="element-383">
                {stat.value}
              </p>
              <p className="text-gray-300 text-sm md:text-base font-medium" data-id="element-384">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}